export default __webpack_public_path__ + "static/media/rozbudowa1.b7c93cbd.svg";